<template lang="pug">
.favourites
	button(v-if="isFavourite", @click="handleClick")
		svg(v-if="iconType == 'gray'", width="24", height="24", viewBox="0 0 24 24", fill="none", xmlns="http://www.w3.org/2000/svg")
			path(
				d="M16.5 3C14.76 3 13.09 3.81 12 5.085C10.91 3.81 9.24 3 7.5 3C4.415 3 2 5.415 2 8.5C2 12.275 5.4 15.36 10.55 20.035L12 21.35L13.45 20.035C18.6 15.36 22 12.275 22 8.5C22 5.415 19.585 3 16.5 3Z",
				fill="#FF6600"
			)
		svg(v-else, width="16", height="16", viewBox="0 0 16 16", fill="none", xmlns="http://www.w3.org/2000/svg")
			path(
				d="M7.61987 3.7149L7.99992 4.15946L8.37997 3.7149C9.01499 2.9721 9.99119 2.5 10.9999 2.5C12.7804 2.5 14.1666 3.88614 14.1666 5.66667C14.1666 6.76069 13.6784 7.79401 12.717 8.97024C11.7499 10.1533 10.3572 11.419 8.63052 12.9865L7.99992 13.5583L7.36932 12.9865C7.36926 12.9864 7.3692 12.9863 7.36914 12.9863C5.64256 11.419 4.24989 10.1533 3.28288 8.97024C2.32147 7.79401 1.83325 6.76069 1.83325 5.66667C1.83325 3.88614 3.21939 2.5 4.99992 2.5C6.00865 2.5 6.98484 2.9721 7.61987 3.7149Z",
				fill="#FF6600",
				stroke="white"
			)
	button(v-else, @click="handleClick")
		svg(v-if="iconType == 'gray'", width="24", height="24", viewBox="0 0 32 32", fill="none", xmlns="http://www.w3.org/2000/svg")
			path(
				d="M22.0003 4C19.6803 4 17.4537 5.08 16.0003 6.78C14.547 5.08 12.3203 4 10.0003 4C5.88699 4 2.66699 7.22 2.66699 11.3333C2.66699 16.3667 7.20033 20.48 14.067 26.7133L16.0003 28.4667L17.9337 26.7133C24.8003 20.48 29.3337 16.3667 29.3337 11.3333C29.3337 7.22 26.1137 4 22.0003 4ZM16.1403 24.74L16.0003 24.8667L15.8603 24.74C9.52033 18.9867 5.33366 15.1867 5.33366 11.3333C5.33366 8.67333 7.34033 6.66667 10.0003 6.66667C12.0537 6.66667 14.0537 7.99333 14.7537 9.81333H17.2403C17.947 7.99333 19.947 6.66667 22.0003 6.66667C24.6603 6.66667 26.667 8.67333 26.667 11.3333C26.667 15.1867 22.4803 18.9867 16.1403 24.74Z",
				fill="#C5C5C5"
			)
		svg(v-else, width="16", height="16", viewBox="0 0 16 16", fill="none", xmlns="http://www.w3.org/2000/svg")
			path(
				d="M10.9999 2C9.83992 2 8.72659 2.54 7.99992 3.39C7.27325 2.54 6.15992 2 4.99992 2C2.94325 2 1.33325 3.61 1.33325 5.66667C1.33325 8.18333 3.59992 10.24 7.03325 13.3567L7.99992 14.2333L8.96659 13.3567C12.3999 10.24 14.6666 8.18333 14.6666 5.66667C14.6666 3.61 13.0566 2 10.9999 2ZM8.06992 12.37L7.99992 12.4333L7.92992 12.37C4.75992 9.49333 2.66659 7.59333 2.66659 5.66667C2.66659 4.33667 3.66992 3.33333 4.99992 3.33333C6.02659 3.33333 7.02659 3.99667 7.37659 4.90667H8.61992C8.97325 3.99667 9.97325 3.33333 10.9999 3.33333C12.3299 3.33333 13.3333 4.33667 13.3333 5.66667C13.3333 7.59333 11.2399 9.49333 8.06992 12.37Z",
				fill="white"
			)
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
export default {
	data: () => ({
		isFavourite: false
	}),
	props: {
		mid: {
			type: String,
			required: true
		},
		liked: {
			type: Boolean,
			required: true
		},
		iconType: {
			typ: String,
			required: false
		}
	},
	watch: {
		liked: {
			handler(val) {
				this.isFavourite = val;
			},
			immediate: true
		}
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn'])
	},
	methods: {
		async sendFavourite() {
			await axios.post(`/private/favourites/${this.mid}`);
			this.isFavourite = !this.isFavourite;
			window.ipEventBus.publish('is-liked-change', { isLiked: this.isFavourite });
			if (this.isFavourite) {
				this.$gtm.trackEvent({
					event: 'propertyLike',
					propertyID: this.mid
				});
			}
		},
		handleClick(e) {
			if (!this.isLoggedIn) {
				this.openLoginForm(e);
			} else {
				this.sendFavourite();
			}
		},
		openLoginForm(e) {
			window.ipEventBus.publish('open-login-form', e);
		},
		handleAngularEvents() {
			window.ipEventBus.subscribe('is-liked-change-angular', (channel, { isliked, mId }) => {
				if (mId == this.mid) {
					this.isFavourite = isliked;
				}
			});
		}
	},
	created() {
		this.handleAngularEvents();
	}
};
</script>
<style lang="css" scoped>
.favourites {
	z-index: 10;
}

.favourites button {
	background-color: transparent;
	border: none;
	padding: 0;
}
</style>